import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/OrderNowPrompt.css";
import { ArrowRight, Package, Sprout, Truck, Users } from "../components/Icons";

const STEPS = [
  {
    icon: <Sprout />,
    title: "A farm opens a campaign",
    body: "We publish what is available — the animal, the cuts, the sizes and the closing date.",
  },
  {
    icon: <Users />,
    title: "The community orders together",
    body: "Neighbours each claim a share. Buying the whole animal at once is what keeps the price fair.",
  },
  {
    icon: <Package />,
    title: "We process and pack",
    body: "Once the campaign closes, your portion is prepared, portioned and packed for its trip.",
  },
  {
    icon: <Truck />,
    title: "It arrives at your door",
    body: "Delivered across Calgary within 7 business days of the campaign closing.",
  },
];

const OrderNowPrompt = () => {
  return (
    <section id="how-it-works" className="section order-prompt" aria-labelledby="order-prompt-title">
      <div className="container">
        <div className="section-head" data-reveal>
          <span className="eyebrow">How it works</span>
          <h2 id="order-prompt-title">
            Four steps from the farm to your <span className="order-highlight">freezer</span>
          </h2>
          <p>
            No subscriptions to untangle and no guesswork — just a straightforward group buy that
            puts better food within reach.
          </p>
        </div>

        <ol className="steps-grid">
          {STEPS.map((step, index) => (
            <li
              className="step-card"
              key={step.title}
              data-reveal
              style={{ "--reveal-delay": `${index * 80}ms` }}
            >
              <span className="step-card-icon">{step.icon}</span>
              <span className="step-card-number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>

        <div className="steps-cta" data-reveal>
          <Link to="/order-now" className="btn btn--lg">
            Order Now
            <ArrowRight />
          </Link>
          <Link to="/track-order" className="btn btn--lg btn--ghost">
            Track an existing order
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OrderNowPrompt;
